import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  Input,
  QueryList,
} from '@angular/core';
import { CdkAccordion } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@lockton-apps/material';
import { ToggleListItemComponent } from './toggle-list-item.component';

@Component({
  selector: 'la-toggle-list',
  imports: [CommonModule, MaterialModule],
  templateUrl: './toggle-list.component.html',
  styleUrls: ['./toggle-list.component.scss'],
  providers: [{ provide: CdkAccordion, useExisting: ToggleListComponent }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleListComponent extends CdkAccordion implements AfterViewInit {
  @Input() visibilityLimit!: number;
  @Input() totalLabel!: string;

  isOpen!: boolean;

  @ContentChildren(ToggleListItemComponent)
  items!: QueryList<ToggleListItemComponent>;

  get isLimitExceeded() {
    return this.items.length > this.visibilityLimit;
  }

  constructor(public readonly cdr: ChangeDetectorRef) {
    super();
  }

  ngAfterViewInit() {
    this.toggleItems(false);
    this.listenToItemsChanges();
  }

  toggleItems(isOpen: boolean) {
    this.isOpen = isOpen;

    this.items.forEach((item: ToggleListItemComponent, index: number) => {
      const isVisible: boolean = this.isOpen || index < this.visibilityLimit;

      item.visibility = isVisible ? 'visible' : 'hidden';
    });

    this.cdr.markForCheck();
  }

  private listenToItemsChanges(): void {
    this.items.changes.subscribe(() => {
      this.toggleItems(this.isOpen);
    });
  }
}
